import { Component } from "react";
import axios from "./api.service";

export default class UnityService extends Component {
	static async createUnity(unity) {
		let form = new FormData();
		form.append("title", unity.title);
		form.append("level", unity.selectedLevel);
		form.append("resume", unity.resume);
		form.append("audio", unity.audio);
		form.append("order", unity.order);

		return axios.post(`/unity/create`, form, {
			header: { "Content-Type": "multipart/form-data" },
		});
	}

	static async listAllUnits() {
		return axios
			.get(`/unity/getAll`)
			.then((res) => {
				return res.data;
			})
			.catch((err) => {
				return [];
			});
	}

	static async getUnitsfromLevel(levelId) {
		return axios
			.get(`/unity/getUnitsfromLevel/${levelId}`)
			.then((res) => {
				return res.data;
			})
			.catch((err) => {
				return [];
			});
	}

	static async listOneUnity(id) {
		return axios
			.get(`/unity/getOne/${id}`)
			.then((res) => {
				return res.data.unity;
			})
			.catch((err) => console.error);
	}

	static async updateUnity(id, unity) {
		return axios
			.put(`/unity/edit/${id}`, unity)
			.then((res) => console.log)
			.catch((err) => console.error);
	}

	static async deleteUnity(id) {
		return axios.delete(`/unity/delete/${id}`);
	}
}
